export enum UploadStatus {
  NotStarted = 0,
  InProgress = 1,
  Success = 2,
  GeneralError = 3,
  FileSizeError = 4,
  FileTypeError = 5,
}

export enum CallStatus {
  Processing = 'Processing',
  Complete = 'Complete',
  Failed = 'Failed',
  Finalizing = 'Finalizing',
}

export enum ApiSummaryStatus {
  SummarizationSavedOnline = 'SUMMARIZATION_SAVED_ONLINE',
  SummarizationFailure = 'SUMMARIZATION_FAILURE',
  FlattenFailure = 'SUMMARIZATION_FLATTEN_FAILURE',
  SpeakerDiarizationComplete = 'SPEAKER_DIARIZATION_SUCCESS',
}

export enum UserRole {
  Sales = 'sales',
  Compliance = 'compliance',
  Servicing = 'servicing',
  SuperUser = 'super-user',
  SalesManager = 'sales-manager',
}

export enum Permission {
  SalesUpload = 'sales_upload_call',
  SalesUploadView = 'sales_upload_view',
  SalesSummaryView = 'sales_summary_view',
  SalesSearchCall = 'sales_search_call',
  ServicingUpload = 'servicing_upload_call',
  ServicingUploadView = 'servicing_upload_view',
  ServicingSummaryView = 'servicing_summary_view',
  ComplianceUpload = 'compliance_upload_call',
  ComplianceUploadView = 'compliance_upload_view',
  ComplianceSummaryView = 'compliance_summary_view',

  ADMINView = 'ADMIN_view',
  SMView = 'SM_view',
  LAView = 'LA_view',
  SearchCallAll = 'search_call_all',
  SearchLAAll = 'search_la_all',
  SearchSMAll = 'search_sm_all',
}

export enum FileType {
  Audio = 'audio',
  Pdf = 'pdf',
}

export enum ApiRunConfigStatus {
  Pending = 'PENDING',
  InProgress = 'INPROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

export enum RunConfigStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum PipelineType {
  Hmda = 'HMDA',
  Sales = 'SALES',
  Servicing = 'SERVICING',
  Batch = 'BATCH',
  Idp = 'IDP',
  NotDefined = 'NOT_DEFINED',
  Copilot = 'COPILOT',
}

export enum PipelineNames {
  SALES = 'sales_pipeline',
  HMDA = 'hmda',
  SERVICING = 'servicing',
  NOT_DEFINED = 'not_defined_pipeline',
  COPILOT = 'copilot_pipeline',
}

export enum FeedbackSentiment {
  Positive = 'POSITIVE',
  Negative = 'NEGATIVE',
}

export enum IntentTags {
  Sales = 'sales',
  Servicing = 'servicing',
  Hmda = 'hmda',
  Copilot = 'copilot',
}

export enum Period {
  Daily = 'daily',
  Week = 'week',
  Month = 'month',
}

export enum DateRangePeriod {
  Yesterday = 'yesterday',
  ThisWeek = 'this week',
}

export enum AnalyticsPageType {
  SalesManager = 'sales-manager',
  LoanAdvisor = 'loan-advisor',
}
